<!--  -->
<template>
    <div class="main">
        <!-- 标题  -->
        <p class="title-Individual-center">
            <span>道具管理</span>
            <i class="el-icon-arrow-right"></i>
            <span>{{ routeName }}</span>
            <i class="el-icon-arrow-right"></i>
            <span class="span-Individual-center">{{ list[isIndex] }}</span>
        </p>
        <div class="box">
            <div class="flex-box2">
                <div v-for="item, index in list" :key="index"
                    :class="index == isIndex ? 'text-item active' : 'text-item'" class="firm-clickable" @click="listChange(item, index)">
                    {{ item }}
                </div>
            </div>
            <div style="display: flex;align-items: flex-start;justify-content: space-between; margin-top: 40px;">
                <div class="left">
                    <div :class="cardIndex == index ? 'card-box-active card-box' : 'card-box'"
                        v-for="item, index in textList" :key="index">
                        <div>
                            <div class="title">{{ item.name }}</div>
                            <div class="title2">{{ item.text }}</div>
                        </div>
                        <div>
                            <el-button type="primary" @click="cardChange(item, index)"
                                style="background-color: #3B3025 !important;color: #EFD4B3;border: 0;width: 100px;"> {{
                                    isIndex == 0 ? '购买' : '查看' }}</el-button>
                        </div>
                    </div>
                </div>
                <div class="right" v-if="isIndex == 0 && cardIndex != undefined">
                    <div class="title">{{ textList[cardIndex].name }}购买 </div>
                    <div class="title2 flex-box">
                        <span> 权益选择：</span>
                        <span> （2025年1月12日到期）</span>
                    </div>
                    <div class="flex-box" style="flex-wrap: wrap;">
                        <div v-for="item, index in list2" :key="index"
                            :class="item.checked ? 'change-box change-box-active' : 'change-box'"
                            @click="list2Change(item, index)">{{ item.name }}：{{ item.name2 }}</div>
                    </div>
                    <div class="flex-box">
                        <div class="title2" style="margin: 0;">
                            <span>年限：</span>
                            <el-input-number size="small" v-model="num" :min="1" :max="10" label="描述文字">
                            </el-input-number>
                        </div>
                        <div class="title2" style="margin: 0;">
                            价格：<span style="font-size: 16px;color:#FE574A;">￥3999</span>
                        </div>
                    </div>
                    <div style="display: flex;justify-content: center;margin-top: 25px;">
                        <el-button type="primary" style="width: 100px;" @click="dialogVisible = true">立即购买</el-button>
                    </div>
                    <dialogModel
                        title="付款"
                        :visible.sync="dialogVisible"
                        :footer="false"
                        @handleClose="dialogVisible = false"
                    >
                        <div style="padding: 50px 30% ;">
                            <div class="flex-box">
                                <div style="font-size: 16px;color: #000;">{{ textList[cardIndex].name }}</div>
                                <div style="font-size: 16px;color: #FE574A;">￥266</div>
                            </div>
                            <div class="flex-box" style="margin: 20px 0;">
                                <div style="font-size: 12px;color: #999;">50次/月</div>
                                <div style="font-size: 16px;color: #FE574A;">×2</div>
                            </div>
                            <div class="flex-box" style="margin: 20px 0;">
                                <div class="flex-box">
                                    <img src="@/assets/imgs/gouxuan@3x.svg" alt=""
                                        style="margin-right: 5px;cursor: pointer;">
                                    <img src="@/assets/imgs/weigouxuan@3x.svg" alt=""
                                        style="margin-right: 5px;cursor: pointer;">
                                    侦迹币<span style="font-size: 12px;color: #999;">（剩余55）</span>
                                </div>
                                <div>减<span style="font-size: 14px;color: #FE574A;">￥55</span></div>
                            </div>
                            <div class="flex-box">
                                <div>应付款</div>
                                <div style="font-size: 16px;color: #FE574A;">￥211</div>
                            </div>
                            <div>
                                <div style="text-align: center;color: #999;font-size: 12px;margin: 40px 0 10px;">扫码付款
                                </div>
                                <div>
                                    <img src="@/assets/imgs/erweima2.svg" alt=""
                                        style="display: block; margin: 0 auto;width: 120px;">
                                </div>
                                <div style="display: flex;justify-content: center;margin: 10px 0 ;">
                                    <img src="@/assets/imgs/zhifubao@3x.svg" alt=""
                                        style="margin-right: 20px;">
                                    <img src="@/assets/imgs/weixin@3x.svg" alt="">
                                </div>
                            </div>
                        </div>
                    </dialogModel>
                </div>
                <div class="right2" v-if="isIndex == 1 && cardIndex != undefined">
                    <div class="title">{{ textList[cardIndex].name }} </div>
                    <div class="title2 flex-box">
                        <span> 已有权益：</span>
                    </div>
                    <div style="font-size: 12px;padding: 0 40px;">
                        <div class="flex-box firm-clickable" style="margin-bottom: 15px;" v-for="item, index in list2" :key="index"
                            @click="list2Change(item, index)">
                            <div>
                                <span style="color: #409eff ;">{{ item.name }}：</span>
                                <span>{{ item.name2 }}</span>
                            </div>
                            <div>
                                {{ item.date }}
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 50px;">
                        <div v-for="item, index in list3" :key="index" class="record-list">
                            <div>
                                <span>{{ item.name }}</span>
                                <span style="margin-left: 20px;color: #409eff ;">{{ item.name2 }}</span>
                            </div>
                            <div>
                                <span>{{ item.date }}</span>
                                <span>{{ item.time }}</span>
                            </div>
                        </div>
                    </div>
                    <dialogModel
                        title="付款"
                        :visible.sync="dialogVisible"
                        :footer="false"
                        @handleClose="dialogVisible = false"
                    >
                        <div style="padding: 50px 30% ;">
                            <div class="flex-box">
                                <div style="font-size: 16px;color: #000;">{{ textList[cardIndex].name }}</div>
                                <div style="font-size: 16px;color: #FE574A;">￥266</div>
                            </div>
                            <div class="flex-box" style="margin: 20px 0;">
                                <div style="font-size: 12px;color: #999;">50次/月</div>
                                <div style="font-size: 16px;color: #FE574A;">×2</div>
                            </div>
                            <div class="flex-box" style="margin: 20px 0;">
                                <div class="flex-box">
                                    <img src="@/assets/imgs/gouxuan@3x.svg" alt=""
                                        style="margin-right: 5px;cursor: pointer;">
                                    <img src="@/assets/imgs/weigouxuan@3x.svg" alt=""
                                        style="margin-right: 5px;cursor: pointer;">
                                    侦迹币<span style="font-size: 12px;color: #999;">（剩余55）</span>
                                </div>
                                <div>减<span style="font-size: 14px;color: #FE574A;">￥55</span></div>
                            </div>
                            <div class="flex-box">
                                <div>应付款</div>
                                <div style="font-size: 16px;color: #FE574A;">￥211</div>
                            </div>
                            <div>
                                <div style="text-align: center;color: #999;font-size: 12px;margin: 40px 0 10px;">扫码付款
                                </div>
                                <div>
                                    <img src="@/assets/imgs/erweima2.svg" alt=""
                                        style="display: block; margin: 0 auto;width: 120px;">
                                </div>
                                <div style="display: flex;justify-content: center;margin: 10px 0 ;">
                                    <img src="@/assets/imgs/zhifubao@3x.svg" alt=""
                                        style="margin-right: 20px;">
                                    <img src="@/assets/imgs/weixin@3x.svg" alt="">
                                </div>
                            </div>
                        </div>
                    </dialogModel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            routeName: "",
            dialogVisible: false,
            list: ['道具权益', '已购道具'],
            isIndex: 0,
            textList: [
                {
                    name: '侦迹全',
                    text: '保障权益，让雇主更放心，订单更安全',
                    value: 1
                },
                {
                    name: '信息卡',
                    text: '可用于查看我的商机中的信息，每次消耗一张',
                    value: 2
                },
                {
                    name: '提醒卡',
                    text: '可用于提醒营业执照到期时间，每次提醒消耗一张',
                    value: 3
                }
            ],
            list2: [
                {
                    name: '准',
                    name2: '不准时/不达标必赔',
                    id: 1,
                    checked: false,
                    date: '2025年1月12日到期'
                },
                {
                    name: '保',
                    name2: '未完成必赔',
                    id: 2,
                    checked: false,
                    date: '2025年1月12日到期'
                },
                {
                    name: '原',
                    name2: '保障原创',
                    id: 3,
                    checked: false,
                    date: '2025年1月12日到期'
                },
                {
                    name: '源',
                    name2: '保障提供源文件/码',
                    id: 4,
                    checked: false,
                    date: '2025年1月12日到期'
                },
                {
                    name: '修',
                    name2: '修改到满意为止',
                    id: 5,
                    checked: false,
                    date: '2025年1月12日到期'
                },
                {
                    name: '价',
                    name2: '中途不加价',
                    id: 6,
                    checked: false,
                    date: '2025年1月12日到期'
                }],
            num: 1,
            cardIndex: undefined,
            list3: [
                {
                    name: '准权益购买',
                    name2: '+3年',
                    date: '2024年03月16日',
                    time: '15:46',
                },
                {
                    name: '准权益购买',
                    name2: '+3年',
                    date: '2024年03月16日',
                    time: '15:46',
                },
                {
                    name: '准权益购买',
                    name2: '+3年',
                    date: '2024年03月16日',
                    time: '15:46',
                }
            ]
        };
    },
    created() {
        this.routeName = this.$route.name;
    },
    mounted() {

    },
    methods: {
        listChange(item, index) {
            this.isIndex = index
            this.cardIndex = undefined
        },
        list2Change(item, index) {
            item.checked = !item.checked
        },
        cardChange(item, index) {
            this.cardIndex = index
        }
    },

};
</script>
<style lang='less' scoped>
.box {
    width: 100%;
    min-height: 700px;
    box-sizing: border-box;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    padding: 30px;

    .left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .card-box {
            width: 680px;
            height: 140px;
            background-image: url(../../../../assets/imgs/kapian@3x.svg);
            padding: 20px 20px 20px 30px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            .title {
                font-size: 20px;
                font-weight: 700;
                color: #fff;
            }

            .title2 {
                font-size: 12px;
                color: #3B3025;
                margin-top: 20px;
            }
        }

        .card-box-active {
            box-shadow: 0px 0px 5px 0px rgba(97, 144, 232, 1);
            box-sizing: border-box;
            border-radius: 15px;
        }
    }

    .right {
        width: 450px;
        height: 430px;
        background: #FFFFFF;
        box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
        border-radius: 20px;
        padding: 30px 20px;
        box-sizing: border-box;

        .title {
            font-size: 16px;
            color: #409eff ;
        }

        .title2 {
            font-size: 12px;
            color: #666;
                margin: 25px 0;

        }

        .change-box {
            width: 45%;
            height: 35px;
            line-height: 35px;
            background: #FFFFFF;
            border: 1px solid #409eff ;
            font-size: 12px;
            text-align: center;
            color: #409eff ;
            cursor: pointer;
            margin-bottom: 20px;
            border-radius: 5px;
        }

        .change-box-active {
            background: rgba(97, 144, 232, 0.27);

        }
    }

    .right2 {
        width: 440px;
        height: 670px;
        background: #FFFFFF;
        box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
        border-radius: 20px;
        padding: 30px 10px;
        box-sizing: border-box;

        .title {
            font-size: 16px;
            color: #409eff ;
            font-weight: 700;
        }

        .title2 {
            font-size: 12px;
            color: #666;
            font-weight: 700;
            margin: 25px 0;
        }

        .record-list {
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            box-sizing: border-box;
            height: 35px;
            line-height: 35px;
            background: #FFFFFF;
            border: 1px solid #DDDDDD;
            border-radius: 10px;
            font-size: 12px;
            margin-top: 15px;
        }
    }

    .text-item {
        background-color: #eee;
        width: 110px;
        font-size: 12px;
        padding: 10px 5px;
        text-align: center;
        margin-right: 20px;
        border-radius: 5px;
        cursor: pointer;
        box-sizing: border-box;
    }

    .active {
        background-color: rgba(97, 144, 232, 0.20);
        color: #409eff ;
    }
}
</style>